import React from "react";
import { Star, Quote } from "lucide-react";

const TESTIMONIOS = [
  {
    nombre: "María del Carmen Rodríguez",
    perfil: "Compró departamento en Guadalajara",
    tag: "Adquisición",
    quote:
      "Estaba a punto de firmar con mi banco de toda la vida cuando decidí consultar con Brillo Finance. Me encontraron una tasa 2.3 puntos más baja con otra institución. En 20 años, eso representa un ahorro de más de $480,000 pesos.",
    iniciales: "MR",
    color: "#f05c3e",
  },
  {
    nombre: "Jorge Luis Hernández",
    perfil: "Sustitución de hipoteca en Zapopan",
    tag: "Ahorro de $4,200/mes",
    quote:
      "Mi hipoteca me cobraba 12.5% de tasa. Con Brillo Finance hice una sustitución y ahora pago 9.1%. Mi mensualidad bajó $4,200 pesos. En 14 meses ya me ahorré más de $58,000. Lo mejor: ¡no me cobraron ni un peso!",
    iniciales: "JL",
    color: "#04b0ba",
  },
  {
    nombre: "Lucía García Morales",
    perfil: "Primera vivienda en Tlaquepaque",
    tag: "Adquisición",
    quote:
      "Era mi primer crédito hipotecario, no entendía el producto ni el proceso. En Brillo Finance me llevaron de la mano en todo: comparar opciones, reunir documentos, la firma con el notario. Hoy la mensualidad es menor a lo que pagaba de renta.",
    iniciales: "LG",
    color: "#f05c3e",
  },
  {
    nombre: "Ana Patricia Solís",
    perfil: "Empresaria en Puerto Vallarta",
    tag: "Liquidez",
    quote:
      "Necesitaba liquidez para invertir en mi negocio pero los créditos personales tenían tasas altísimas. Brillo Finance me consiguió un crédito con garantía hipotecaria a una tasa increíble. Recibí $1.2 millones y mi mensualidad es completamente manejable.",
    iniciales: "AP",
    color: "#04b0ba",
  },
  {
    nombre: "Roberto y Fernanda Torres",
    perfil: "Construcción en Tlajomulco de Zúñiga",
    tag: "Construcción",
    quote:
      "Construimos nuestra casa de los sueños gracias a Brillo Finance. El crédito de construcción es más complejo, pero ellos coordinaron todo con el banco y el constructor. Los desembolsos fueron puntuales y el proceso fue mucho más ágil de lo que imaginaba.",
    iniciales: "RF",
    color: "#f05c3e",
  },
  {
    nombre: "Carlos Mendoza Ríos",
    perfil: "Adquisición en Tonalá",
    tag: "Adquisición",
    quote:
      "Ya había ido a 3 bancos y todos me daban condiciones diferentes. Estaba confundido y frustrado. Brillo Finance me organizó todo en una tabla comparativa clara y me explicó pros y contras de cada opción. Tomé una decisión informada. Servicio excepcional.",
    iniciales: "CM",
    color: "#04b0ba",
  },
];

export default function TestimoniosSection() {
  return (
    <section id="testimonios" className="py-16 bg-[#f8f9fa]" data-testid="testimonios-section">
      <div className="bf-container">
        <div className="grid lg:grid-cols-12 gap-6 items-end">
          <div className="lg:col-span-7">
            <p className="bf-eyebrow">Historias reales</p>
            <h2 className="mt-2 font-display text-3xl sm:text-4xl text-[#333333]">
              Lo que dicen nuestros clientes de{" "}
              <span className="text-[#f05c3e]">Jalisco</span>.
            </h2>
          </div>
          <div className="lg:col-span-5 flex flex-col lg:items-end gap-1">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={`rating-${i}`} className="h-4 w-4 fill-[#f05c3e] text-[#f05c3e]" />
              ))}
              <span className="ml-2 font-display text-base text-[#333333]">4.9 / 5</span>
            </div>
            <p className="text-xs text-[#666666]">
              <strong className="text-[#333333]">+2,500 créditos</strong> gestionados · <strong className="text-[#333333]">98%</strong> nos recomienda
            </p>
          </div>
        </div>

        <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {TESTIMONIOS.map((t, i) => (
            <article
              key={t.nombre}
              data-testid={`testimonio-card-${i}`}
              className="relative rounded-xl bg-white border border-[#e5e7eb] p-5 transition-all hover:-translate-y-1 hover:shadow-md"
            >
              <Quote
                className="absolute top-4 right-4 h-6 w-6 opacity-15"
                style={{ color: t.color }}
              />
              <div className="flex items-center gap-1 mb-2">
                {[...Array(5)].map((_, k) => (
                  <Star key={`${t.nombre}-star-${k}`} className="h-3 w-3 fill-[#f05c3e] text-[#f05c3e]" />
                ))}
              </div>
              <p className="text-sm text-[#333333] leading-relaxed">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-4 flex items-center gap-3 pt-4 border-t border-[#e5e7eb]">
                <div
                  className="h-10 w-10 rounded-full flex items-center justify-center text-white font-display text-sm flex-shrink-0"
                  style={{ background: t.color }}
                >
                  {t.iniciales}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-sm text-[#333333] truncate">{t.nombre}</p>
                  <p className="text-xs text-[#666666] truncate">{t.perfil}</p>
                </div>
                <span
                  className="text-[10px] uppercase tracking-wider font-semibold px-2 py-0.5 rounded"
                  style={{ background: `${t.color}15`, color: t.color }}
                >
                  {t.tag}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
